import React, { useState, useEffect } from 'react';
import { useBrowserDetection } from '../../utils/browserUtils';
import { AppSidebar, MobileHeader } from './AppSidebar';

interface AppLayoutProps {
  children: React.ReactNode;
}

const SIDEBAR_HEADER_HEIGHT_PX = 60;

export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const { safeCSS } = useBrowserDetection();

  // Mobile only state
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // Desktop only state (persisted)
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    const saved = localStorage.getItem('sseeaa_sidebar_collapsed');
    return saved === 'true';
  });

  // Sync with localStorage
  useEffect(() => {
    localStorage.setItem('sseeaa_sidebar_collapsed', String(isSidebarCollapsed));
  }, [isSidebarCollapsed]);

  const handleScroll = (e: React.UIEvent<HTMLElement>) => {
    setIsScrolled(e.currentTarget.scrollTop > 0);
  };

  return (
    <div className="flex flex-col h-screen">
      <MobileHeader
        isMenuOpen={isMenuOpen}
        onToggleMenu={() => setIsMenuOpen(!isMenuOpen)}
        isScrolled={isScrolled}
      />

      <div className="flex flex-1 overflow-hidden">
        {/* Mobile menu overlay */}
        {isMenuOpen && (
          <div
            className="md:hidden fixed inset-0 bg-transparent z-40 transition-opacity"
            style={{ top: 0 }}
            onClick={() => setIsMenuOpen(false)}
          />
        )}

        <AppSidebar
          isMenuOpen={isMenuOpen}
          isCollapsed={isSidebarCollapsed}
          onCollapseToggle={setIsSidebarCollapsed}
          onItemClick={() => setIsMenuOpen(false)}
        />

        {/* Main content */}
        <main
          className="bg-bgb flex-1 overflow-y-auto relative scrollbar-hide"
          style={{
            paddingBottom: safeCSS.bottomSafeArea
          }}
          onScroll={handleScroll}
        >
          {/* Mobile padding wrapper */}
          <div
            className="md:hidden h-full flex flex-col"
            style={{ paddingTop: `calc(${safeCSS.topSafeArea} + ${SIDEBAR_HEADER_HEIGHT_PX}px)` }}
          >
            {children}
          </div>
          {/* PC content (no extra padding) */}
          <div className="hidden md:block h-full">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export { LabelingLanding as LabelMainLayout } from '../../features/labeling/LabelingLanding';
